<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Freight WareHouse Execution
            <small class="ml-2"><b-badge variant="info">{{
              ffExportDetail.portType == "Icd"
                ? " Stuffing At ICD"
                : " Stuffing At PORT (Port Stuffing)"
            }}</b-badge></small>
          </b-navbar-brand>
        </b-navbar>
        <banner-component v-if="ALLMODULE" :allModuleIdBanner="ALLMODULE" :jobSeriesBanner="JOBSERIES"
          :bannerClientName="mainEntryData.length > 0 ? mainEntryData[0].clientName : ''" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <b-button :disabled="viewPagePref == 1" size="sm" class="pull-right" @click="showDocModal"
                variant="dark">Upload Documents</b-button>
              <container-component v-if="ALLMODULE" :allModuleIdContainer="ALLMODULE" JOB="FF" />
            </div>

            <div v-if="proceedNext == '1'">
              <md-layout gutter class="labelMargtop">
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>WareHouse Name</label>
                    <b-form-input :disabled="viewPagePref == 1" :formatter="capitalizeAll" name="nameOfCFS"
                      id="nameOfCFS" v-model="WarehouseStuffing.nameOfCFS"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!WarehouseStuffing.nameOfCFS">{{
                    nameOfCFSError
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="20">
                  <label>VGM Submission Date</label>
                  <date-picker :disabled="viewPagePref == 1" :format="selectDateFormat" lang="en"
                    name="vgmSubmissionDate" id="vgmSubmissionDate" v-model="WarehouseStuffing.vgmSubmissionDate"
                    :minute-step="1"></date-picker>
                  <span class="error" v-if="WarehouseStuffing.vgmSubmissionDate_err">{{
                    WarehouseStuffing.vgmSubmissionDate_err
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="gateInDate">SI Submission date</label>
                  <date-picker :disabled="viewPagePref == 1" lang="en" id="gateInDate" type="datetime"
                    format="YYYY-MM-DD hh:mm a" :minute-step="1" name="gateInDate"
                    v-model="WarehouseStuffing.siSubmissionDate"></date-picker>
                  <span class="error" v-if="WarehouseStuffing.siSubmissionDate_err">{{
                    WarehouseStuffing.siSubmissionDate_err
                  }}</span>
                  <!-- <span class="error" v-if="!factoryStuffing.gateInDate">{{errorExecution.gateInDate}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="trSubmissionDate">TR Submission date</label>
                  <date-picker :disabled="viewPagePref == 1" lang="en" id="trSubmissionDate" type="datetime"
                    format="YYYY-MM-DD hh:mm a" :minute-step="1" name="trSubmissionDate"
                    v-model="WarehouseStuffing.trSubmissionDate"></date-picker>
                  <span class="error" v-if="WarehouseStuffing.trSubmissionDate_err">{{
                    WarehouseStuffing.trSubmissionDate_err
                  }}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Handover Date</label>
                  <date-picker :disabled="viewPagePref == 1" :format="selectDateFormat" lang="en" name="handoverDate"
                    id="handoverDate" v-model="WarehouseStuffing.handoverDate" :minute-step="1"></date-picker>
                  <span class="error" v-if="WarehouseStuffing.handoverDate_err">{{
                    WarehouseStuffing.handoverDate_err
                  }}</span>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label for="gateInDate">Gate-In date time</label>
                    <date-picker
                      :disabled="WarehouseStuffing.vgmSubmissionDate==''"
                      lang="en"
                      id="gateInDate"
                      type="datetime"
                      format="YYYY-MM-DD hh:mm a"
                      :minute-step="1"
                      name="gateInDate"
                      v-model="WarehouseStuffing.gateInDate"
                    ></date-picker>
                    <span class="error" v-if="!factoryStuffing.gateInDate">{{errorExecution.gateInDate}}</span> 
                  </md-layout>
                </md-layout>-->
              <md-layout md-gutter class="labelMargtop"> </md-layout>
              <md-layout class="gutr" gutter v-if="ffExportDetail.portType == 'Icd'">
                <md-layout md-flex="25">
                  <label>
                    <u>Custom Clearance</u>
                  </label>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop" v-if="ffExportDetail.portType == 'Icd'">
                <md-layout md-flex="20">
                  <label for="custmClearByPridel">CC to be done by Pridel</label>

                  <model-list-select :isDisabled="viewPagePref == 1" :list="CCList"
                    v-model="WarehouseStuffing.custmClearByPridel" option-value="ccInfoVal" option-text="ccInfoText"
                    placeholder="Select"></model-list-select>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>CC Assignment No.</label>
                    <b-form-input :disabled="viewPagePref == 1" :formatter="capitalizeAll" name="ccAsignmentNo"
                      id="ccAsignmentNo" v-model="WarehouseStuffing.ccAsignmentNo"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <div>
                <b-button class="mt-3 smbutnWidth" variant="primary" @click="addFactoryExecution('SAVE')"
                  id="addButtonLoaderVGM">Save & Submit</b-button>
                <md-spinner md-indeterminate id="loaderVGM" style="display: none"></md-spinner>
              </div>
<b-row>
                  <b-col md="12" class="mt-2" v-if="ALLMODULE">
                  <UpdateContainerWithSOB
                    :allModuleId="Number(ALLMODULE)" :JobNo="JOBSERIES"  @update="getData" />
                </b-col>
              </b-row>
              <!-- <md-layout md-gutter v-if="ffExportDetail.mergeffExportId!='0'">
                  <md-layout md-flex="5"></md-layout>
                  <h4 style="color:green;letter-spacing:1px">
                    Note : Your B/L is merge with this
                    <u>{{ffExportDetail.mergeSeries}}</u>
                  </h4>
                </md-layout> -->
              <div>
                <!-- <div md-gutter>
                  <b-button class="mt-1" variant="primary" @click="addFactoryExecution('VGM')"
                    id="addButtonLoaderVGM">Save & Proceed To VGM</b-button>
                  <md-spinner md-indeterminate id="loaderVGM" style="display: none"></md-spinner>
                </div> -->
                <div md-gutter>
                  <!-- <b-button
                    class="mt-1"
                    variant="primary"
                    @click="addFactoryExecution('PAY')"
                    id="addButtonLoaderVGM"
                    >Save & Proceed To S-Line Payment</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderVGM"
                    style="display: none"
                  ></md-spinner> -->
                  <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
                  <span class="error" v-if="AppovalMSG">{{AppovalMSG}}</span><br/>
                  <b-button class="mt-1" variant="primary" @click="addFactoryExecution('PAYTEST')"
                    id="addButtonLoaderVGM">Save & Proceed To S-Line Payment</b-button>
                  <md-spinner md-indeterminate id="loaderVGM" style="display: none"></md-spinner>
                  <br />
                  <ResetSlineSubscription  v-if="ALLMODULE && is_approval_mail_action>0" :allModuleId="Number(ALLMODULE)" :JobNo="JOBSERIES" @refresh-data="getData" /><br v-if="ALLMODULE && is_approval_mail_action>0" />
                </div>
                <div md-gutter>
                  <b-button class="mt-1" v-if="
                    !ffExportDetail.mergeffExportId ||
                    ffExportDetail.mergeffExportId == 0
                  " variant="primary" @click="addFactoryExecution('BLRaised')" id="addButtonLoaderBL">Save & Proceed
                    to Raise B/L</b-button>
                  <md-spinner md-indeterminate id="loaderBL" style="display: none"></md-spinner>
                </div>
                <div md-gutter>
                  <b-button class="mt-1" variant="primary" @click="addFactoryExecution('handover')"
                    id="addButtonLoaderRail">{{
                      ffExportDetail.portType == "Icd"
                        ? "Save & Proceed to Handover to Rail"
                        : "Save & Proceed to Gate ­ in at Terminal By Road"
                    }}</b-button>
                  <!-- {{ffExportDetail.portType=='Icd'?"Save & Proceed to Handover to Rail":"Save & Proceed to Gate ­ in at Terminal By Road"}} -->
                  <md-spinner md-indeterminate id="loaderRail" style="display: none"></md-spinner>
                  <br />
                </div>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal size="xl" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
        title="">
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="sendMail"
      ref="popMail"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose7"
      ref="addPop7"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop2"
      @close="onClose"></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import ContainerComponent from "../allModuleForm/containerComponent.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import ResetSlineSubscription from '../common/ResetSlineSubscription.vue';
import UpdateContainerWithSOB from '../Pendency/UpdateContainerWithSOB.vue';

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editExportFCLId") != undefined &&
      this.$sessionsStorage.get("editExportFCLId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffexecutionWareHouse");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName = arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      is_approval_mail_action:0,
      AppovalMSG:'',
      viewPagePref: this.$sessionsStorage.get("user_view_page_pref"),
      ON_Type: "",
      ffSlinePayId: "",
      selectDateFormat,
      visible: true,
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      mainEntryData: [],
      ALLMODULE: "",
      JOBSERIES: "",
      getLocationList: [],
      ffExportDetail: {
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
      },

      SBDetail: {
        shippingSBId: "",
        shippingBillDate: "",
        shippingBillNo: "",
        cargoGrossWeight: "",
        invoiceUpload: "",
        cargoUpload: "",
        shippingInvoiceNo: "",
        shippingInvoiceDate: "",
        shippingBillUpload: "",
      },

      errorSBExecution: {
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        trSubmissionDate: "",
        handoverDate: "",

        vgmSubmissionDate_err: "",
        siSubmissionDate_err: "",
        trSubmissionDate_err: "",
        handoverDate_err: "",

        ffExecutionId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      showMoreSB: false,

      errorExecution: {
        // cartingDate: "",
        // crnNumber: ""
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],

      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
    };
  },

  mounted() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    DocForm,
    ContainerComponent,
    BannerComponent,
    ResetSlineSubscription,
    UpdateContainerWithSOB,
  },
  computed: {
    proceedNext() {
      return this.$store.getters.storeProceedContainer;
    },
    proceedFurther() {
      if (this.containerTypeDetailFactory.length > 0) {
        let arrayG = this.containerTypeDetailFactory.filter((x) => {
          return x.containerNo;
        });

        return arrayG.length == this.containerTypeDetailFactory.length ? true : false;
      } else {
        return false;
      }
    },
    viewInvoicedDoc() {
      return this.SBDetail.invoiceUpload != ""
        ? this.SBDetail.invoiceUpload.split(",")
        : [];
    },
    viewShippingdDoc() {
      return this.SBDetail.shippingBillUpload != "" &&
        this.SBDetail.shippingBillUpload != null
        ? this.SBDetail.shippingBillUpload.split(",")
        : [];
    },
    viewCargoDoc() {
      return this.SBDetail.cargoUpload != "" ? this.SBDetail.cargoUpload.split(",") : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    onFileChange(ID) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", this.$sessionsStorage.get("editExportFCLId"));
        if (ID == "Invoice") {
          formData.append("staticFileName", "Sea_Export_Ware_ShipperInvoice");
        } else if (ID == "Cargo") {
          formData.append("staticFileName", "Sea_Export_Ware_Cargolist");
        } else {
          formData.append("staticFileName", "Sea_Export_Ware_ShippingBill");
        }

        //  formData.append("upload_dir_folderName", "FF_Sea_Export_Uploads");
        formData.append(
          "upload_dir_folderName",
          this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "Invoice") {
            this.SBDetail.invoiceUpload = result.data;
          } else if (ID == "Cargo") {
            this.SBDetail.cargoUpload = result.data;
          } else {
            this.SBDetail.shippingBillUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let shipperInvoiceNoArry = [];
        let containerNoArry = [];
        let customSealNoArry = [];
        let lineSealNoArry = [];
        let shippingBillNoArry = [];
        let shippingBillDateArry = [];

        this.sbDetailArray.map((x) => {
          shipperInvoiceNoArry.push(x.shippingInvoiceNo);
          shippingBillNoArry.push(x.shippingBillNo);
          shippingBillDateArry.push(x.shippingBillDate);
        });

        this.containerTypeDetailFactory.map((x) => {
          containerNoArry.push(x.containerNo);
          customSealNoArry.push(x.customSealNo);
          lineSealNoArry.push(x.LineSealNo);
        });

        let newData = {
          mail: "FF",
          clientName: this.ffExportDetail.clientName,
          assignmentNo: this.ffExportDetail.ffExportFclSeries,
          POR: this.ffExportDetail.POR,
          FinalPlace: this.ffExportDetail.FinalPlace,
          shippingLine: this.ffExportDetail.shippingLine,
          wareHouseExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
          ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
          containerNoArry: containerNoArry,
          lineSealNoArry: lineSealNoArry,
          customSealNoArry: customSealNoArry,
          shipperInvoiceNoArry: shipperInvoiceNoArry,
          sLineBookingNo: this.BookingShippingLine.bookingNumber,
          vesselName: this.BookingShippingLine.vesselName,
          voyyageNo: this.BookingShippingLine.voyageNo,
          suCutoff: this.BookingShippingLine.SICutOff,
          noOfContainers: containerNoArry.length,
          shippingBillDateArry: shippingBillDateArry,
          shippingBillNoArry: shippingBillNoArry,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendExecutionDetailsToClient.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
            })
            .catch((error) => { });
        }
      }
    },
    openPop() {
      this.alert.content = "Send Assignment Details To Client ..?";
      this.$refs["popMail"].open();
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      // if (this.ffExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ffExportFcl",
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffBooking",
      //   });
      // }
      window.history.go(-1);
    },
    onFileChangeInvoice() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionInvoiceSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.invoiceUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    onFileChangeShipping() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionShipUpWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.shippingBillUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onFileChangeCargo() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionCargoSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.cargoUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onClose(type) {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editSalesExId", this.ALLMODULE);
      if (type != "cancel") {
        if (
          // this.ffExportDetail.portType == "Icd" &&
          this.nextPageType == "handover"
        ) {
          this.$router.push({
            path: "/freightForward/newHandoverToRail",
          });
        } else if (this.nextPageType == "VGM") {
          this.$router.push({
            path: "/freightForward/newVgmDetail",
          });
        } else if (this.nextPageType == "BLRaised") {
          this.$router.push({
            path: "/freightForward/fclBLofLanding",
          });
        } else if (this.nextPageType == "PAY") {
          this.$router.push({
            path: "/freightForward/ffSLinePaymentExport",
          });
        } else if (this.nextPageType == "PAYTEST") {
          if (
            this.ON_Type == "New" ||
            this.ffSlinePayId == "" ||
            this.ffSlinePayId == undefined
          ) {
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExportN_VP",
              // path: "/freightForward/ffSLinePaymentExportNew",
            });
          } else {
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExport",
            });
          }
          // this.$router.push({
          //   path: "/freightForward/ffSLinePaymentExportN_VP",
          //   // path: "/freightForward/ffSLinePaymentExportNew",
          // });
        }
      }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_container",
          tableId: "ffExecutionContainerId",
          isActive: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => { });
      }
    },
    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },

    DeleteListSb(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop7"].open();
    },
    addSBDetail() {
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.invoiceUpload) {
        let obj = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SHIPPER_INVOICE",
          docLink: this.SBDetail.invoiceUpload,
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.cargoUpload) {
        let obj1 = {
          allModuleId: this.ALLMODULE,
          docName: "BL_LINEINVOICEREQ",
          docLink: this.SBDetail.cargoUpload,
        };
        this.SBDetail.uploadArray.push(obj1);
      }
      if (this.SBDetail.shippingBillUpload) {
        let obj2 = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SB",
          docLink: this.SBDetail.shippingBillUpload,
        };
        this.SBDetail.uploadArray.push(obj2);
      }
      let new_data = {
        SBDetail: this.SBDetail,
        WarehouseStuffing: this.WarehouseStuffing,
      };

      this.validateSBDetail();
      if (this.validateSB != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addSBWareHouseExecution.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }

              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });
              Object.keys(this.errorSBExecution).map((x) => {
                this.errorSBExecution[x] = "";
              });
              this.getData();
            }
          })
          .catch((error) => { });
      }
    },
    validateExecution() {
      let validate_new = true;
      // Object.keys(this.errorExecution).map((x, index) => {
      //   if (this.WarehouseStuffing[x] == "") {
      //     this.errorExecution[x] = this.arrayExecutionError[index];
      //     validate_new = false;
      //   }
      // });

      if (
        this.WarehouseStuffing.nameOfCFS == "" &&
        this.WarehouseStuffing.portType == "Icd"
      ) {
        this.nameOfCFSError = "Enter name of CFS";
      } else {
        this.nameOfCFSError = "";
      }

      if (this.containerTypeDetailFactory.length == 0) {
        this.errorAtleastContainer = "Select Atleast one Container";

        validate_new = false;
      } else {
        this.errorAtleastContainer = "";
      }

      if (this.sbDetailArrayList.length == 0) {
        this.showMoreSB = true;
        this.errorAtleastSb = "Select Atleast one Shipping Details";
        validate_new = false;
      } else {
        this.showMoreSB = false;
        this.errorAtleastSb = "";
      }

      if (validate_new == false) {
        if (this.errorAtleastContainer == "") {
          window.scroll(0, 50);
        }

        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    checkSlinePayment() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "FF Export",
          allModuleId: this.ALLMODULE,
          assignment_no: this.JOBSERIES,
          type: this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        if (payLoad != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkSlinePaymentcreated.php`,
            data: JSON.stringify(payLoad),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                  this.syncType = data.moduleType;
                  this.syncSeries = data.mainSalesSeries;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }
                this.syncFlag = true;
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => { });
        }
      });
    },
    verifyJoBWiseContainer() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "FF Export",
          allModuleId: this.ALLMODULE,
          assignment_no: this.JOBSERIES,
          type: this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        NodeLockPannelService.verifyContainer(payLoad)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);

          return resolve(data);
        })
        .catch((error) => {
          console.log("Catch on verifyJoBWiseContainer Error: ", error);
        });
      });
    },
    async addFactoryExecution(id) {
      this.nextPageType = id;
      if (id == "PAYTEST") {
        let checkContValueExit = await this.verifyJoBWiseContainer();
        console.log('checkContValueExit=>', checkContValueExit.data[0])

        if (!checkContValueExit.data[0].isCountMatching && checkContValueExit.data[0].subsFailedStatus) {
          this.alert.content = checkContValueExit.message;
          this.$refs["addPop"].open();
          return false;
        }

        let checkValueExit = await this.checkSlinePayment();
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          if (this.syncType != "FF Export") {
            this.alert.content =
              "The Payment Request has Already been Raised in '" +
              this.syncType +
              "' Assignment No. '" +
              this.syncSeries +
              "'";
            this.$refs["addPop"].open();
            return false;
          }
        }
      }

      // if (
      //   this.nextPageType == "handover" &&
      //   (this.WarehouseStuffing.gateInDate == "" ||
      //     this.WarehouseStuffing.vgmSubmissionDate == "")
      // ) {
      //   this.alert.content =
      //     "VGM Submission Date and Gate-In Date must be entered before proceeding to Handover";
      //   this.$refs["addPop"].open();
      //   return false;
      // }

      if (this.validateTrans != false) {
        if (id == "handover") {
          $("#addButtonLoaderRail").css("display", "none");
          $("#loaderRail").css("display", "block");
        }
        if (id == "BLRaised") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        }
        if (id == "VGM") {
          $("#addButtonLoaderVGM").css("display", "none");
          $("#loaderVGM").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addWareHouseExecution.php`,
          data: JSON.stringify(this.WarehouseStuffing),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              if (id == "handover") {
                $("#loaderRail").css("display", "none");
                $("#addButtonLoaderRail").css("display", "block");
              }
              if (id == "BLRaised") {
                $("#loaderBL").css("display", "none");
                $("#addButtonLoaderBL").css("display", "block");
              }
              if (id == "VGM") {
                $("#loaderVGM").css("display", "none");
                $("#addButtonLoaderVGM").css("display", "block");
              }
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                if (
                  this.WarehouseStuffing.vgmSubmissionDate &&
                  this.WarehouseStuffing.siSubmissionDate &&
                  this.WarehouseStuffing.trSubmissionDate &&
                  this.WarehouseStuffing.handoverDate
                ) {
                  this.$refs["addPop2"].open();
                }
              }
              if (this.nextPageType == "SAVE") {
                this.getData();
              }
              if (
                id == "BLRaised" ||
                id == "handover" ||
                id == "VGM" ||
                id == "PAYTEST"
              ) {
                if (!this.WarehouseStuffing.vgmSubmissionDate) {
                  this.WarehouseStuffing.vgmSubmissionDate_err =
                    "Please Enter VGM Submission Date";
                }
                if (!this.WarehouseStuffing.siSubmissionDate) {
                  this.WarehouseStuffing.siSubmissionDate_err =
                    "Please Enter SI Submission Date";
                }
                if (!this.WarehouseStuffing.trSubmissionDate) {
                  this.WarehouseStuffing.trSubmissionDate_err =
                    "Please Enter TR Submission Date";
                }
                if (!this.WarehouseStuffing.handoverDate) {
                  this.WarehouseStuffing.handoverDate_err = "Please Enter Handover Date";
                }
              }
            }
          })
          .catch((error) => { });
      }
    },

    validateContainer() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let validate_new = true;
      Object.keys(this.errorContainer).map((x, index) => {
        if (
          this.ContainerTypeSizefactory[x] == "" ||
          this.ContainerTypeSizefactory[x] == null
        ) {
          this.errorContainer[x] = this.arrayContainerError[index];
          validate_new = false;
        }
      });

      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
        validate_new = false;
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
        validate_new = false;
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    factoryStuffingContainer() {
      if (this.getContainerList.length > 0) {
        let array_new = this.getContainerList;
        if (this.ContainerTypeSizefactory.containerTypeId != "") {
          let new_array = array_new.filter((x) => {
            return x.containerTypeId == this.ContainerTypeSizefactory.containerTypeId;
          });

          if (new_array.length > 0) {
            this.ContainerTypeSizefactory.containerType = new_array[0].containerType;
          }
        }
      }

      let new_data = {
        ContainerTypeSizefactory: this.ContainerTypeSizefactory,
        WarehouseStuffing: this.WarehouseStuffing,
      };

      this.validateContainer();

      if (this.validateTrans != false) {
        $("#addButtonLoaderfactory").css("display", "none");
        $("#loaderfactory").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addWareHouseContainer.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderfactory").css("display", "none");
              $("#addButtonLoaderfactory").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });

              Object.keys(this.errorContainer).map((x) => {
                this.errorContainer[x] = "";
              });

              this.getData();
            }
          })
          .catch((error) => { });
      }
    },

    DeleteList(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
    },

    onClose7(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_sb",
          tableId: "shippingSBId",
          isActive: "isAcitveSB",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              // this.JqueryFun();
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => { });
      }
    },

    viewEditSB(id, index) {
      let array = this.sbDetailArray.filter((x) => {
        return x.shippingSBId == id;
      });

      Object.keys(this.SBDetail).map((x) => {
        this.SBDetail[x] = array[0][x];
      });
    },
    getData() {
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        exPage: "1",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
            this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editFFExecutionId")) {
                this.$sessionsStorage.set("editFFExecutionId", data.autoExecutionId);
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT = data.ContainerFromTPT[0].ContainerNumber.split(",");
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT = data.ContainerFromTPT[0].ContainerType.split(
                  ","
                );
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            this.getLocationList = data.portLocationArray;

            if (data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            if (data.editFFEX.length > 0) {
              this.mainEntryData = data.editFFEX;
              this.is_approval_mail_action= data.editFFEX[0].is_approval_mail_action;
              this.AppovalMSG = data.editFFEX[0].AppovalMSG;
              this.WarehouseStuffing.portType = data.editFFEX[0].portType;
              this.WarehouseStuffing.stuffingType = data.editFFEX[0].stuffingType;
              this.WarehouseStuffing.containerInfo = data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
              this.ALLMODULE = data.editFFEX[0].allModuleId;
              this.JOBSERIES = data.editFFEX[0].ffExportFclSeries;
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
    viewExecutionDetail() {
      this.doLoading();
      let new_data = {
        allModuleID: this.ALLMODULE,
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ffExportDetail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewExecutionDetail.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.ffExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ffExecutionDetail[0][x] || "";
              });
            }
            this.ON_Type = data.ffseaType;
            this.ffSlinePayId = data.ffSlinePayId;
            // alert(this.ON_Type);
            // alert(this.ffSlinePayId);
            //  this.ON_Type = "";
            // this.ffSlinePayId = "";
            console.log("ffseaType=>", data.ffseaType);
            console.log("ffSlinePayId=>", data.ffSlinePayId);
            console.log("ffseaType_query=>", data.ffseaType_query);
            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => { });
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newFFExecutionWareHouse.vue?cd4719b4